import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

//NEW
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetProducts, AddProduct, UpdateProduct, DeleteProduct } from 'services/inventory/product.service';
import { GetUserTypes } from 'services/dropdown/dropdown.service';
import { GetUOMs } from 'services/other/uom.service';
import { GetUnits, SignUp, GetUsers, UpdateUser } from 'services/user/user.service';
import { GetShops } from 'services/other/shop.service';
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn, ImageColumn, ActiveInactivColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { ProductValidationSchema } from 'utilities/ValidationSchema/Inventory/ProductValidationSchema';
import duplicateNameChecker from 'utilities/duplicateNameChecker';

const Registration = () => {
    const { shopList, shopListLoading } = useSelector((state) => state.shopList);
    const { userTypeList } = useSelector((state) => state.userType);
    const { usersList, usersLoading } = useSelector((state) => state.users);
    const { userUpdate, userUpdateLoading } = useSelector((state) => state.userUpdate);
    const { productList, productListLoading } = useSelector((state) => state.productList);
    const { productAdd, productAddLoading } = useSelector((state) => state.productAdd);
    const { productUpdate, productUpdateLoading } = useSelector((state) => state.productUpdate);
    const { categoryList } = useSelector((state) => state.categories);
    const { uomList } = useSelector((state) => state.uomList);
    const { unitList, unitListLoading } = useSelector((state) => state.units);
    const { registration, registrationLoading } = useSelector((state) => state.registration);

    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [showUpdateForm, setShowUpdateForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [btnLoading, setBtnLoading] = useState(false); // * state for loading button
    const [autoShopFilteredValue, setAutoShopFilteredValue] = useState([]);
    const [autoUserTypeFilteredValue, setAutoUserTypeFilteredValue] = useState([]);

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();

    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        user_type: "",
        shop: "",
        units: "",
        is_active: false,
    };

    const updateInitialValue = {
        id: updateData?.id || 0,
        email: updateData?.email || "",
        user_type: userTypeList?.find((value) => value.id === updateData?.user_type),
        shop: shopList?.find((value) => value.id === updateData?.shop),
        units: updateData?.unit || "",
        is_active: updateData?.is_active || false,
    };
    

    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        // validationSchema: ProductValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                user_type: values?.user_type?.id || 0,
                shop: values?.shop?.id || 0,
            };

            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const updateFormik = useFormik({
        initialValues: updateData ? updateInitialValue : '', // * if state is update then updateData state value will show up
        // validationSchema: ProductValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            const modifiedData = {
                ...values,
                user_type: values?.user_type?.id || 0,
                shop: values?.shop?.id || 0,
            }
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const editUser = (user) => {
        setShowUpdateForm(true); // * set the form to true
        setUpdateData(user);
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateUser(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(SignUp(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowUpdateForm(false); // * close the form
        setBtnLoading(false); // * loading button state to false
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetUnits());
        dispatch(GetShops());
        dispatch(GetUsers());
        dispatch(GetUserTypes());
    }, [registration, userUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "get_full_name", header: "Name", sortableBody: NameColumn },
        { field: "email", header: "Email", sortableBody: NameColumn },
        { field: "user_type_name", header: "User Type", sortableBody: NameColumn },
        { field: "is_active", header: "Status", sortableBody: ActiveInactivColumn },
        { field: "shop_name", header: "Shop", sortableBody: NameColumn },
        { field: "units", header: "Units", sortableBody: NameColumn },
    ];

    const searchShop = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && shopList !== undefined) {
                setAutoShopFilteredValue([...shopList]);
            } else {
                setAutoShopFilteredValue(
                    shopList?.filter((shop) => {
                        return shop.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchUserType = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && userTypeList !== undefined) {
                setAutoUserTypeFilteredValue([...userTypeList]);
            } else {
                setAutoUserTypeFilteredValue(
                    userTypeList?.filter((user_type) => {
                        return user_type.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };


        // * input data array of object for the form / modal
        const inputData = [
            {
                id: "first_name",
                name: "first_name",
                type: "text",
                labelFor: "First Name",
                label: "First Name",
                required: true,
                messagePosition: 'toast',
                className: "col-12 md:col-12",
            },
            {
                id: "last_name",
                name: "last_name",
                type: "text",
                labelFor: "Last Name",
                label: "Last Name",
                required: true,
                messagePosition: 'toast',
                className: "col-12 md:col-12",
            },
            {
                id: "email",
                name: "email",
                value: "email",
                type: "text",
                labelFor: "Email",
                label: "Email",
                required: true,
                messagePosition: 'toast',
                rows: '1',
                className: "col-12 md:col-12",
                onBlur: (e) => duplicateNameChecker(e.target.value, usersList, updateData, setDuplicateNameExist),
            },
            {
                id: "password",
                name: "password",
                value: "password",
                type: "password",
                labelFor: "Password",
                label: "Password",
                required: true,
                messagePosition: 'toast',
                rows: '1',
                className: "col-12 md:col-12",
            },
            {
                id: "user_type",
                name: "user_type",
                type: "select",
                labelFor: "User Type",
                label: "Select User Type",
                required: true,
                className: "col-12 md:col-12",
                autoFilteredValue: autoUserTypeFilteredValue,
                autoCompleteMethod: searchUserType,
                selectedAutoValue: userTypeList,
            },
            {
                id: "shop",
                name: "shop",
                type: "select",
                labelFor: "Shop",
                label: "Select Shop",
                required: true,
                className: "col-12 md:col-12",
                autoFilteredValue: autoShopFilteredValue,
                autoCompleteMethod: searchShop,
                selectedAutoValue: categoryList,
            },
            {
                id: "units",
                name: "units",
                value: "units",
                type: "multipleselect",
                labelFor: "Select Units",
                label: "Select Units",
                placeholder: "Select Units",
                options: unitList,
                required: true,
                rows: '1',
                className: "col-12 md:col-12",
            },
            {
                id: "is_active",
                name: "is_active",
                type: "switch",
                labelFor: "Is Active",
                label: "Is Active",
                required: true,
                className: "col-12 md:col-12",
                switchChecked: Boolean(formik.values.is_active),
                setSwitchChecked: (e) => formik.setFieldValue("is_active", Number(e.value)),
            },
        ];
    
        const updateInputData = [
            {
                id: "email",
                name: "email",
                value: "email",
                type: "text",
                labelFor: "Email",
                label: "Email",
                required: true,
                messagePosition: 'toast',
                rows: '1',
                className: "col-12 md:col-12",
                onBlur: (e) => duplicateNameChecker(e.target.value, usersList, updateData, setDuplicateNameExist),
            },
            {
                id: "user_type",
                name: "user_type",
                type: "select",
                labelFor: "User Type",
                label: "Select User Type",
                required: true,
                className: "col-12 md:col-12",
                autoFilteredValue: autoUserTypeFilteredValue,
                autoCompleteMethod: searchUserType,
                selectedAutoValue: userTypeList,
            },
            {
                id: "shop",
                name: "shop",
                type: "select",
                labelFor: "Shop",
                label: "Select Shop",
                required: true,
                className: "col-12 md:col-12",
                autoFilteredValue: autoShopFilteredValue,
                autoCompleteMethod: searchShop,
                selectedAutoValue: categoryList,
            },
            {
                id: "units",
                name: "units",
                value: "units",
                type: "multipleselect",
                labelFor: "Select Units",
                label: "Select Units",
                placeholder: "Select Units",
                options: unitList,
                required: true,
                rows: '1',
                className: "col-12 md:col-12",
            },
            {
                id: "is_active",
                name: "is_active",
                type: "switch",
                labelFor: "Is Active",
                label: "Is Active",
                required: true,
                className: "col-12 md:col-12",
                switchChecked: Boolean(updateFormik.values.is_active),
                setSwitchChecked: (e) => updateFormik.setFieldValue("is_active", Number(e.value)),
            },
        ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
            
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editUser(rowData)} />
            </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="User Details"
                tableColumns={tableColumns}
                data={usersList}
                loading={usersLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            
            <CreateModal 
                dialogVisible={showForm} 
                column={3} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={"Create User"} 
                modalWidth="500px" 
                reset={resetForm} 
                btnLoading={registrationLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={6}
                col2={updateData ? 2 : 3}
                col3={4}
            />

            <CreateModal 
                dialogVisible={showUpdateForm} 
                column={3} 
                onHide={hideModal} 
                inputData={updateInputData} 
                formik={updateFormik} 
                dialogHeader={"Update user's unit permission"} 
                modalWidth="500px" 
                reset={resetForm} 
                btnLoading={userUpdateLoading} 
                update={updateData} 
                col1={6}
                col2={updateData ? 2 : 3}
                col3={4}
            />
        </>
    );
};

export default Registration;
